import React from "react";
import styled from "styled-components";
import { AdminButton } from "../../../pages/admin/action_engine";

import {
  AdminTable,
  AdminTableViewport,
} from "../../../pages/admin/section_engine";

import {
  formatInventoryCoverage,
  formatInventoryDemand,
  formatInventoryQuantity,
  getInventoryProductLabel,
  getInventoryStatusPresentation,
} from "./inventoryPresentation";


export default function InventoryList({
  items,
  selectedProductUuid = "",
  onSelectItem,
}) {
  return (
    <TableViewport>
      <InventoryTable>
        <thead>
          <tr>
            <th scope="col">Produit</th>
            <th scope="col">Stock physique</th>
            <th scope="col">Réservé</th>
            <th scope="col">Disponible</th>
            <th scope="col">Vitesse de vente</th>
            <th scope="col">Couverture</th>
            <th scope="col">Statut</th>
            <th scope="col">Sélection</th>
          </tr>
        </thead>

        <tbody>
          {items.map((item) => {
            const status =
              getInventoryStatusPresentation(
                item.stock_status,
              );

            const selected = (
              selectedProductUuid
              === item.product_uuid
            );

            return (
              <tr key={item.product_uuid}>
                <td>
                  <ProductIdentity>
                    <strong>
                      {item.product_name
                        || "Produit sans nom"}
                    </strong>

                    {item.product_reference && (
                      <span>
                        {item.product_reference}
                      </span>
                    )}
                  </ProductIdentity>
                </td>

                <td>
                  {formatInventoryQuantity(
                    item.stock_on_hand,
                  )}
                </td>

                <td>
                  {formatInventoryQuantity(
                    item.reserved_quantity,
                  )}
                </td>

                <td>
                  {formatInventoryQuantity(
                    item.available_quantity,
                  )}
                </td>

                <td>
                  {formatInventoryDemand(
                    item.average_daily_demand,
                  )}
                </td>

                <td>
                  {formatInventoryCoverage(
                    item.coverage_days,
                  )}
                </td>

                <td>
                  <StatusBadge $tone={status.tone}>
                    {status.label}
                  </StatusBadge>
                </td>

                <td>
                  <SelectButton
                    type="button"
                    aria-pressed={selected}
                    aria-label={`Sélectionner ${getInventoryProductLabel(
                      item,
                    )}`}
                    onClick={() => onSelectItem(item)}
                    $selected={selected}
                  >
                    {selected
                      ? "Sélectionné"
                      : "Sélectionner"}
                  </SelectButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </InventoryTable>
    </TableViewport>
  );
}


const TableViewport = styled(AdminTableViewport)`
  width: 100%;
  overflow-x: auto;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 16px;
`;


const InventoryTable = styled(AdminTable)`
  width: 100%;
  min-width: 1050px;
  border-collapse: collapse;
  background: #202a43;

  th,
  td {
    padding: 0.85rem;
    border-bottom:
      1px solid rgba(255, 255, 255, 0.07);
    text-align: left;
    vertical-align: middle;
  }

  th {
    color: rgba(247, 247, 247, 0.62);
    font-size: 0.76rem;
    font-weight: 850;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  tbody tr:last-child td {
    border-bottom: 0;
  }
`;


const ProductIdentity = styled.div`
  display: grid;
  gap: 0.25rem;

  span {
    color: rgba(247, 247, 247, 0.58);
    font-size: 0.8rem;
  }
`;


const StatusBadge = styled.span`
  display: inline-flex;
  padding: 0.3rem 0.55rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 850;

  background:
    ${({ $tone }) => {
      if ($tone === "success") {
        return "rgba(73, 184, 126, 0.16)";
      }

      if ($tone === "warning") {
        return "rgba(230, 174, 64, 0.18)";
      }

      if ($tone === "danger") {
        return "rgba(225, 95, 95, 0.16)";
      }

      return "rgba(255, 255, 255, 0.08)";
    }};

  color:
    ${({ $tone }) => {
      if ($tone === "success") {
        return "#8ce0b2";
      }

      if ($tone === "warning") {
        return "#ffd585";
      }

      if ($tone === "danger") {
        return "#ffaaaa";
      }

      return "rgba(247, 247, 247, 0.68)";
    }};
`;


const SelectButton = styled(AdminButton)`
  min-height: 38px;
  padding: 0.55rem 0.75rem;
  border: 1px solid rgba(255, 255, 255, 0.13);
  border-radius: 10px;
  background:
    ${({ $selected }) => (
      $selected
        ? "#f8f3e7"
        : "#151d31"
    )};
  color:
    ${({ $selected }) => (
      $selected
        ? "#151d31"
        : "#f7f7f7"
    )};
  font-weight: 800;
  cursor: pointer;
`;
